import { WorkspaceTimezone } from "@common/workspaceTimezone";
import { toWorkspaceDate } from "./date";

interface GetEarliestSelfServeBookkeepingStartDateParams {
    now: Date;
    timezone: WorkspaceTimezone;
}

export function getEarliestSelfServeBookkeepingStartDate({
    now,
    timezone,
}: GetEarliestSelfServeBookkeepingStartDateParams): string {
    const today = toWorkspaceDate({ date: now, timezone });
    const previousYear = Number(today.slice(0, 4)) - 1;
    return `${previousYear}-01-01`;
}
